import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { IPageRoles } from "./page-roles";
import { IRouteRoles } from "./route-roles";
import { IQueryCommand } from "@features/filter";
import { IPagedData } from "@features/grid";
import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";


@Injectable({
    providedIn: "root"
})
export class RoutesService extends BaseDataService {
    url = "api/route";
    public attemptedUrl: string;

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    getApiRouteRoles(): Promise<IRouteRoles[]> {
        return this.httpGet("api-routes-roles");
    }

    getPageRoles(): Promise<IPageRoles[]> {
        return this.httpGet("pages-roles");
    }

    getPageByApiUrl(queryCommand: IQueryCommand, apiUrl: string): Promise<IPagedData<any>> {
        return this.handleRequest(
            this.http.get<IPagedData<any>>(apiUrl, { params: this.constructHttpParams(queryCommand) }),
            this.handlersFactory.getForReadByFilter()
        );
    }

    getCurrentUserAllowedRoutesPaths(): Promise<string[]> {
        return this.httpGet("me");
    }
}